const isMobile =
  typeof window !== "undefined" && window.innerWidth <= 768;

export const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 1,
      delayChildren: 0,
    },
  },
};

export const childVariants = {
  hidden: { opacity: 0, y: isMobile ? -20 : -50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 1.4, ease: "easeOut" },
  },
};

export const whiteBoxVariants = {
  hidden: { x: isMobile ? "50vw" : "100vw", opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: "easeInOut",
      delay: 4.8,
    },
  },
};

export const colContainerVariants = {
  hidden: {},
  slideOut: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 5.2,
      ease: "easeInOut",
    },
  },
};

export const colVariants = {
  hidden: { y: 0, opacity: 1, transformOrigin: "bottom" },
  slideOut: {
    y: isMobile ? "50vw" : "100vw",
    opacity: 0,
    scaleY: isMobile ? 0.9 : 0.8,
    scaleX: isMobile ? 0.9 : 0.8,
    transition: { duration: 0.8, ease: "easeInOut" },
  },
};

export const contactIconVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 1.2,
      ease: "easeInOut",
      delay: 3.8,
    },
  },
};

export const gradientVariants = {
  visible: { opacity: 1 },
  fadeOut: {
    opacity: 0,
    transition: {
      duration: 1,
      ease: "easeInOut",
      delay: 5.2,
    },
  },
};

export const headerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.2,
      ease: "easeInOut",
      delay: 5.6,
    },
  },
};

export const overlaySlideVariants = {
  visible: {
    x: 0,
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    zIndex: 10000,
    backgroundColor: "transparent",
  },
  slideOut: {
    x: isMobile ? "-50vw" : "-100vw",
    transition: {
      duration: 0.8,
      ease: "easeInOut",
      delay: 5.2,
    },
  },
};
